interface ErrorType {
  [key: string]: string;
}

export const errors: ErrorType = {
  /** /accounts/login */
  LoginFailedException: '아이디와 비밀번호를 확인해주세요',
  AccountDuplicatedException: '이미 가입된 아이디 입니다.',
  AccountNotFoundException:
    '해당 정보로 가입된 계정정보를 찾을 수 없습니다. \n입력정보를 확인해주세요',
  EntityNotFoundError: '해당 계정을 찾을 수 없습니다.',
  GetPrescriptionNoPermissionException:
    '처방전 가격 입력 시간이 초과하였습니다.',

  /** /order/pickup-check/download */
  OrdersNotFoundException: '조회된 주문내역이 없습니다.'
};

export const BFF_ERROR_CODE_TYPES = {
  Default: 'Default',
  DoseRecordFail: 'DoseRecordFail',
  NotFound: 'NotFound',
  NoEarningPoint: 'NoEarningPoint',
  InternalServer: 'InternalServer',
  NoAuthorization: 'NoAuthorization',
  PointEarnFailed: 'PointEarnFailed',
  PayFailed: 'PayFailed',
  HealthRecordFailed: 'HealthRecordFailed',
  BlockAccountFailed: 'BlockAccountFailed',
  DoctorUpdateFailed: 'DoctorUpdateFailed',
  FamilyDoctorRegisterFailed: 'FamilyDoctorRegisterFailed',
  FamilyDoctorRemoveFailed: 'FamilyDoctorRemoveFailed',
  HealthInsuranceSimpleAuthFailed: 'HealthInsuranceSimpleAuthFailed',
  HealthInsuranceScrapingFailed: 'HealthInsuranceScrapingFailed',
  DeliveryReceiptFailed: 'DeliveryReceiptFailed'
} as const;

/**
 * BFF 에러
 *
 * 서버에서 보내주는 에러 메세지가 항상 유저에게 보여줄 수 있는 텍스트로 내려오지 않기 때문에 사용을 지양합니다.
 * 따라서 에러 코드를 읽어 코드별로 전달해주고 싶은 메세지를 기록하여 전달하도록 작성되었습니다.
 *
 * Default의 경우는 추가되지 않은 코드이거나 일반적이지 않은 케이스의 경우에 노출되도록 설계되어있습니다.
 */
export type BFF_ERROR_CODE_TYPES =
  typeof BFF_ERROR_CODE_TYPES[keyof typeof BFF_ERROR_CODE_TYPES];

export const BFF_ERROR_MESSAGES: Record<BFF_ERROR_CODE_TYPES, string> = {
  Default: '일시적인 오류입니다.',
  DoseRecordFail: '복약일수 기록에 실패했습니다.',
  NotFound: '정보를 찾을 수 없습니다.',
  NoEarningPoint: '받을 포인트가 없습니다.',
  InternalServer: '서버 내부에 에러가 있습니다.',
  NoAuthorization: '권한이 없습니다.',
  PointEarnFailed: '포인트 획득에 실패했습니다.',
  PayFailed: '결제에 실패했습니다.',
  HealthRecordFailed: '건강 기록에 실패했습니다.',
  BlockAccountFailed: '대상 ID 블럭에 실패했습니다.',
  DoctorUpdateFailed: '의사 정보 수정에 실패했습니다.',
  FamilyDoctorRegisterFailed: '전담의사 등록에 실패했습니다.',
  FamilyDoctorRemoveFailed: '전담의사 삭제에 실패했습니다.',
  HealthInsuranceSimpleAuthFailed: '간편 인증에 실패했습니다.',
  HealthInsuranceScrapingFailed: '스크래핑 요청 중 문제가 발생했습니다.',
  DeliveryReceiptFailed: '배송 접수에 실패했습니다.'
};
